import getCachedEvaOrganizations from '@/core/services/eva/get-cached-eva-organizations';

async function fetchEvaOrganizations() {
  try {
    return await getCachedEvaOrganizations();
  } catch (error) {
    console.error('Failed to fetch EVA organizations in proxy', error);
    return [];
  }
}

export default fetchEvaOrganizations;
